import { zoomIdentity, zoomTransform } from "d3-zoom"
import { GraphUiState } from "../ui/GraphUiState"

export class GraphConfig {
            
    public name:string
    public sciGraph:boolean
    public config:GraphUiState

    constructor({name="", sciGraph=false,config={}} = {}) {                
        this.name = name
        this.sciGraph = sciGraph
        this.config =  new GraphUiState(config)
    }    

    static createGraphConfigs(datas:string) {         
        const configs =  ((datas && datas.length > 0)? JSON.parse(datas) as Array<any>: []).map(g => new GraphConfig(g))        
        configs.forEach(c => {
            c.config.transform = zoomIdentity                        
            c.config.refresh = false
        })        
        return configs
    }

}
